import type { VehicleTypeDTO } from "../../search";
import type { RecommendationApiResponseDTO } from "../dtos";
import { RecommendationURLTransformer } from "./recommendation-url.transformer";

export abstract class RecommendationTransformer {
  static adjustImageURL(url: string) {
    if (!url) return url;
    const fixedURL = url.replace(/\\/g, "/");
    return encodeURI(fixedURL);
  }

  static transform(
    params: RecommendationApiResponseDTO,
    photoPath: string,
    baseURL: string,
    vehicleType: VehicleTypeDTO
  ): RecommendationApiResponseDTO {
    return {
      ...params,
      recommendations: params?.recommendations?.map((item) => {
        const uniqueId = String(item.UniqueId ?? "");
        const title = item.Specification?.Title ?? "";
        const yearFabrication = String(
          item.Specification?.YearFabrication ?? ""
        );
        const yearModel = String(item.Specification?.YearModel ?? "");
        const odometer = String(item.Specification?.Odometer ?? "0");
        const price = String(item.Price ?? "0");
        const city = item.Seller?.City ?? "";
        const stateAbbreviation = item.Seller?.State?.split(" ")?.pop() ?? "";
        const noPhoto =
          "https://www.webmotors.com.br/assets/img/webp/vehicle_no_photo.webp?t=1.0.1";
        const photo = item.PhotoPath
          ? `${photoPath}/_fotos/anunciousados/gigante/${item.PhotoPath}`
          : noPhoto;

        return {
          ...item,
          id: uniqueId,
          title: title,
          description: item.Specification?.Version?.Value ?? "",
          price: price,
          location: `${city} ${stateAbbreviation}`.trim(),
          year: `${yearFabrication}/${yearModel}`,
          odometer: odometer,
          image: RecommendationTransformer.adjustImageURL(photo) || "",
          noPhoto,
          url: `${baseURL}/${RecommendationURLTransformer.transform(
            item,
            vehicleType
          )}`,
        };
      }),
    };
  }
}
